<template>
  <div class="companyprofile">
    <mt-header title="企业介绍" fixed>
        <router-link to slot="left">
          <mt-button icon="back" @click="$router.back(-1)"></mt-button>
        </router-link>
    </mt-header>
    <div class="box710">{{ pagedata.introduce ? pagedata.introduce : '暂无介绍' }}</div>
    <div class="box710" v-if="pagedata.album&&pagedata.album.length != 0">
      <a v-for="item in pagedata.album" :href="'https://yuan.znstny.cn/' + item.photo" :key="item"><img :src="'https://yuan.znstny.cn/' + item.photo" alt="" /></a>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      store_id: '',
      pagedata: {}
    };
  },
  created() {
    this.store_id = this.$route.query.store_id || '';
    if (this.store_id) {
      this.getPageData();
    } else {
      Toast('信息有误，请返回重试');
    }
  },
  methods: {
    getPageData() {
      this.$request.post(
        '/front/User/userstoinfo',
        {
          store_id: this.store_id
        },
        res => {
          if (res.status == 1) {
            this.pagedata = res.result;
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.mint-header{
  height: 1rem;
  background: #050f25;
  color: #0efcff;
}
.companyprofile{
  padding-top: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/companyProfile.vue